import axios from 'axios'
import api from './api'
import mstore from "../store/index";
// import qs from 'qs'

let store: any = mstore

class Request {
     http(options: any) {
        let headers = {
            'Content-Type':'application/json',
            'vnet-token':store.state.core.token,
            ...options.headers
        }
        let data = options.data;
        let params = {
            ...options.params
        }
        delete options.headers

        delete options.params

        delete options.data

        let option = {
            baseURL:'/api',
            headers:headers,
            method: 'POST',
            params:params,
            data:data,
            ...options
        }
        return new Promise(function(reslove, reject) {
            axios(option).then(function(response) {
                reslove(response.data)
            }).catch( error => {
                try{
                    if(error.response.status === 701){
                        window.location.href= api.authorize + '?url=' + encodeURIComponent(window.location.href)
                    }
                    reject(error)
                }catch(err){
                    reject(error)
                }
                   
            })
        })



    }

    dateFormat(fmt: string, date: any) {
        let ret;
        let opt: any = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
        }
        return fmt;
    }

}
let request = new Request()
export default request